import type { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ErrorType } from '~/data/ErrorRecord';
import type { AppState } from '~/reducers';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';
import UnknownException from '~/utils/fetch-wrapper/errors/UnknownException';
import logger from '~/utils/logger/logger';

type CaughtThunkApiConfig = {
  state: AppState;
  rejectValue: ErrorType;
};

const createCaughtAsyncThunk = <Returned, ThunkArg = void>(
  prefix: string,
  cb: AsyncThunkPayloadCreator<Returned, ThunkArg, CaughtThunkApiConfig>
) =>
  createAsyncThunk<Returned, ThunkArg, CaughtThunkApiConfig>(
    prefix,
    async (args, thunkAPI): Promise<Returned | ReturnType<typeof thunkAPI.rejectWithValue>> => {
      try {
        return await cb(args, thunkAPI);
      } catch (e) {
        logger.error('Caught error in async thunk:', e);
        if (e instanceof BaseException) {
          return thunkAPI.rejectWithValue(e.firstError);
        }

        return thunkAPI.rejectWithValue(UnknownException.from().firstError);
      }
    }
  );

export default createCaughtAsyncThunk;
